const booleanList = [
  {
    id: 0,
    title: "Yes",
    value: true,
  },
  {
    id: 1,
    title: "No",
    value: false,
  },
];

const eventStatusList = [
  {
    id: 0,
    title: "Completed",
    value: "completed",
  },
  {
    id: 1,
    title: "In Progress",
    value: "in_progress",
  },
  {
    id: 2,
    title: "Not Started",
    value: "not_started",
  },
];

export const staticEntities = {
  booleanList,
  eventStatusList,
};
